import type { ThemeOptions } from '@material-ui/core/styles';

// fiona theme
export default {
  palette: {
    primary: {
      main: '#51277A',
      light: '#E6D8F3',
      dark: '#3D1C5E',
    },
    secondary: {
      main: '#BAA1F6',
      dark: '#14E075',
      light: '#14E075',
    },
  },
} as ThemeOptions;
